module.exports = __webpack_public_path__ + "img/3.845a42be.png";